import React, { useEffect, useState, useContext } from 'react';
import { Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { Table, InputNumber, Form, DatePicker, Image, Avatar, Button, Row, Col, Upload, message, Menu, Dropdown } from 'antd';
import { URL } from '../../../config/api';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { disableSpinner, enableSpinner } from '../../../redux/actions/appActions';
import AuthContext from '../../App/authContext';
import { LoadingOutlined, PlusOutlined, DownOutlined, UserOutlined } from '@ant-design/icons';
import { Select } from 'antd';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');


const { Option } = Select;

const ModalBody = ({close, handleSubmit, project, update, categories, fonts}) => {
    if(!categories) {
        categories = [];
    }

    var newCategories = [];
    categories.forEach((item, index) => {
        var newCategory = {label: item.Name, value: item.Id};
        newCategories.push(newCategory);
    });
    
    if(!fonts) {
        fonts = [];
    }
    const [categoryName, setCategoryName] = useState('Select Category');
    const [categoryId, setCategoryId] = useState(0);
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const [sortIndex, setSortIndex] = useState(0);
    const [size, setSize] = useState('');
    const [materials, setMaterials] = useState('');
    const [preparation, setPreparation] = useState('');
    const [cut, setCut] = useState('');
    const [assemble, setAssemble] = useState('');
    const [instruction, setInstruction] = useState('');
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [realImageUrl, setRealImageUrl] = useState('');
    const [photoProject1, setPhotoProject1] = useState('');
    const [realPhotoProject1, setRealPhotoProject1] = useState('');
    const [photoProject2, setPhotoProject2] = useState('');
    const [realPhotoProject2, setRealPhotoProject2] = useState('');
    const [photoProject3, setPhotoProject3] = useState('');
    const [realPhotoProject3, setRealPhotoProject3] = useState('');
    const [photoProject4, setPhotoProject4] = useState('');
    const [realPhotoProject4, setRealPhotoProject4] = useState('');
    const [photoFile, setPhotoFile] = useState('');
    const [elite, setElite] = useState(false);
    const [eliteVideo, setEliteVideo] = useState('');
    const [fontId, setFontId] = useState(0);
    const [fontName, setFontName] = useState('');

    function handleMenuClick(e) {
        const index = e.key;
        let category = categories[index];
        setCategoryName(category.Name);
        setCategoryId(category.Id);
    }

    const menu = (
        <Menu onClick={handleMenuClick}>
                {categories.map((item, index) => (
                    <Menu.Item key={index}>
                        {item.Name}
                    </Menu.Item>
                ))}
        </Menu>
      );

    const [form] = Form.useForm();
    const uploadButton = (
        <div>
          {loading ? <LoadingOutlined /> : <PlusOutlined />}
          <div style={{ marginTop: 8 }}>Upload</div>
        </div>
      );

    /*useEffect(() => {
        getFonts();
    }, []);*/

    useEffect(() => {
        setRealImageUrl("");
        setRealPhotoProject1("");
        setRealPhotoProject2("");
        setRealPhotoProject3("");
        setRealPhotoProject4("");

        if(!project) {
            setCategoryName("Select Category");
            setCategoryId(0);
            setName("");
            setDescription("");
            setSortIndex(0);
            setSize("");
            setMaterials("");
            setPreparation("");
            setCut("");
            setAssemble("");
            setInstruction("");
            setImageUrl("");
            setPhotoProject1("");
            setPhotoProject2("");
            setPhotoProject3("");
            setPhotoProject4("");
            setPhotoFile("");
            setElite(false);
            setEliteVideo("");
            form.setFieldsValue({
                name: "",
                description: "",
                sortIndex: 0,
                size: "",
                materials: "",
                preparation: "",
                cut: "",
                assemble: "",
                instruction: "",
                elite: false,
                eliteVideo: ""
            })
            
            return;
        }

        setCategoryName(project.CategoryName);
        setCategoryId(project.CategoryId);
        setName(project.Name);
        setDescription(project.Description);
        setSortIndex(project.SortIndex);
        setSize(project.Size);
        setMaterials(project.Materials);
        setPreparation(project.Preparation);
        setCut(project.Cut);
        setAssemble(project.Assemble);
        setInstruction(project.Instruction);
        setImageUrl(project.photoExample);
        setPhotoProject1(project.photoProject1);
        setPhotoProject2(project.photoProject2);
        setPhotoProject3(project.photoProject3);
        setPhotoProject4(project.photoProject4);
        setPhotoFile(project.photoFile);
        setElite(project.Elite==1?true:false);
        setEliteVideo(project.EliteVideo != null? project.EliteVideo : "");
        if(project.Elite == 1 && project.FontId != 0) {
            setFontName(project.Font.Name);
            setFontId(project.Font.Id);
        }

        form.setFieldsValue({
            name: project.Name,
            description: project.Description,
            sortIndex: project.SortIndex,
            size: project.Size,
            materials: project.Materials,
            preparation: project.Preparation,
            cut: project.Cut,
            assemble: project.Assemble,
            instruction: project.Instruction,
            elite: project.Elite==1?true:false,
            eliteVideo: project.EliteVideo != null? project.EliteVideo : ""
        })
    }, [update])

    const onFinish = (values) => {
        handleSubmit({
            categoryId: categoryId,
            name: name,
            description: description,
            photoExample: realImageUrl,
            sortIndex: sortIndex,
            size: size,
            materials: materials,
            preparation: preparation,
            cut: cut,
            assemble: assemble,
            instruction: instruction,
            photoProject1: realPhotoProject1,
            photoProject2: realPhotoProject2,
            photoProject3: realPhotoProject3,
            photoProject4: realPhotoProject4,
            photoFile, photoFile,
            elite: elite,
            eliteVideo: eliteVideo,
            fontId: fontId
        })
    }

    /*const getFonts = async () => {
        const res = await axios.get(`${URL}/font/get_font.php?load_all=1`);
        setFonts(res.data);
    }*/

    function beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    function beforeUploadFile(file) {
        const isZip = file.type === 'application/zip';
        if (!isZip) {
            message.error('You can only upload zip file!');
        }
        const isLt5M = file.size / 1024 / 1024 < 5;
        if (!isLt5M) {
            message.error('File must smaller than 5MB!');
        }
        return isLt5M;
    }

    function handleChange(info) {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }

        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, localImageUrl => {
                    setImageUrl(localImageUrl);
                    setLoading(false);
                }
            );
            
            setRealImageUrl(info.file.response.ImageUrl);
        }
    };

    function handleChange1(info) {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, localImageUrl => {
                    setPhotoProject1(localImageUrl);
                    setLoading(false);
                }
            );
            
            setRealPhotoProject1(info.file.response.ImageUrl);
        }
    };

    function handleChange2(info) {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, localImageUrl => {
                    setPhotoProject2(localImageUrl);
                    setLoading(false);
                }
            );
            
            setRealPhotoProject2(info.file.response.ImageUrl);
        }
    };
    
    function handleChange3(info) {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, localImageUrl => {
                    setPhotoProject3(localImageUrl);
                    setLoading(false);
                }
            );
            
            setRealPhotoProject3(info.file.response.ImageUrl);
        }
    };
    
    function handleChange4(info) {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, localImageUrl => {
                    setPhotoProject4(localImageUrl);
                    setLoading(false);
                }
            );
            
            setRealPhotoProject4(info.file.response.ImageUrl);
        }
    };

    function handleChangeFile(info) {
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }

        console.log("AAA_INFO", info);
        if (info.file.status === 'done') {
            setLoading(false);
            setPhotoFile(info.file.response.FileUrl);
        }
    };

    
    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    function onSelect(categoryId) {
        let category = categories.find(o => o.Id === categoryId);
        setCategoryName(category.Name);
        setCategoryId(category.Id);
    }

    const onFilterOption = (input, option) => {
        if(option.children) {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ? true : false;
        } else if(option.label) {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ? true : false;
        }
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                    <Form.Item>
                            <Select
                                showSearch
                                style={{
                                    width: 200,
                                }}
                                value={categoryName}
                                placeholder="Search Category"
                                filterOption={onFilterOption}
                                onSelect={onSelect}
                                options={newCategories}
                            />
                        </Form.Item>

                        <Form.Item name="name" label="Name" 
                                rules={[
                                    {
                                        required: true,
                                        message: `Name required!`,
                                    },
                                ]}>
                            <input
                                name="name"
                                type="text"
                                placeholder="Name"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="description" label="Description"
                            rules={[
                                {
                                    required: true,
                                    message: `Description is required!`,
                                },
                            ]}>
                            <textarea
                                name="description"
                                type="text"
                                value={description}
                                placeholder="Description"
                                onChange={(e) => setDescription(e.target.value)}
                            />

                        </Form.Item>

                        <Form.Item name="sortIndex" label="Sort Index">
                            <input
                                name="sortIndex"
                                type="number"
                                placeholder="Sort Index"
                                value={sortIndex}
                                onChange={(e) => setSortIndex(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="size" label="Size">
                            <input
                                name="size"
                                type="text"
                                placeholder="Size"
                                value={size}
                                onChange={(e) => setSize(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="materials" label="Materials">
                            <textarea
                                name="materials"
                                type="text"
                                placeholder="Materials"
                                value={size}
                                onChange={(e) => setMaterials(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="preparation" label="Preparation">
                            <textarea
                                name="preparation"
                                type="text"
                                placeholder="Preparation"
                                value={size}
                                onChange={(e) => setPreparation(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="cut" label="Cut">
                            <textarea
                                name="cut"
                                type="text"
                                placeholder="Cut"
                                value={size}
                                onChange={(e) => setCut(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="assemble" label="Assemble">
                            <textarea
                                name="assemble"
                                type="text"
                                placeholder="Assemble"
                                value={size}
                                onChange={(e) => setAssemble(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="instruction" label="Instruction">
                            <textarea
                                name="instruction"
                                type="text"
                                placeholder="Instruction"
                                value={size}
                                onChange={(e) => setInstruction(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="elite" label="Elite Project">
                            <input
                                name="elite"
                                type="checkbox"
                                checked={elite}
                                value={elite}
                                placeholder="Elite Project"
                                onChange={(e) => setElite(e.target.checked)}
                            />
                        </Form.Item>

                        <Form.Item name="fonts" label="Select Font">

                            <Select
                                name="fonts"
                                showSearch
                                style={{ width: 200 }}
                                defaultValue={''}
                                onChange={(newValue) => {
                                    setFontId(newValue);
                                    let font = fonts.find( font => font.Id == newValue );
                                    setFontName(font.Name);
                                }}
                                placeholder="Search Font"
                                optionFilterProp="children">
                                    {fonts.map((item, index) => (
                                        <Option value={item.Id}>{item.Name}</Option>
                                    ))}
                            </Select>

                            <span style={{marginLeft: '12px'}}>{fontName}</span>

                        </Form.Item>

                        <Form.Item name="eliteVideo" label="Elite Video">
                            <input
                                name="eliteVideo"
                                type="text"
                                placeholder="Elite Video"
                                value={eliteVideo}
                                onChange={(e) => setEliteVideo(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="image" label="Image">
                           <Upload
                                name="image"
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${URL}/project/upload_image.php?type=0`}
                                beforeUpload={beforeUpload}
                                onChange={handleChange}
                            >
                                {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                        </Form.Item>

                        <Row>
                            <Col sm={12}>
                                <Form.Item name="image" label="Photo Project 1">
                                <Upload
                                        name="image"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action={`${URL}/project/upload_image.php?type=1`}
                                        beforeUpload={beforeUpload}
                                        onChange={handleChange1}
                                    >
                                        {photoProject1 ? <img src={photoProject1} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                                    </Upload>
                                </Form.Item>
                            </Col>

                            <Col sm={12}>
                                <Form.Item name="image" label="Photo Project 2">
                                    <Upload
                                        name="image"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action={`${URL}/project/upload_image.php?type=2`}
                                        beforeUpload={beforeUpload}
                                        onChange={handleChange2}>
                                        {photoProject2 ? <img src={photoProject2} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                                    </Upload>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Col sm={12}>
                                <Form.Item name="image" label="Photo Project 3">
                                    <Upload
                                        name="image"
                                        listType="picture-card"
                                        className="avatar-uploader"
                                        showUploadList={false}
                                        action={`${URL}/project/upload_image.php?type=3`}
                                        beforeUpload={beforeUpload}
                                        onChange={handleChange3}>
                                        {photoProject3 ? <img src={photoProject3} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                                    </Upload>
                                </Form.Item>
                            </Col>
                            <Col sm={12}>
                            <Form.Item name="image" label="Photo Project 4">
                                <Upload
                                    name="image"
                                    listType="picture-card"
                                    className="avatar-uploader"
                                    showUploadList={false}
                                    action={`${URL}/project/upload_image.php?type=4`}
                                    beforeUpload={beforeUpload}
                                    onChange={handleChange4}>
                                    {photoProject4 ? <img src={photoProject4} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                                </Upload>
                            </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item name="other" label="Other">
                           <Upload
                                name="file"
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${URL}/project/upload_file.php`}
                                beforeUpload={beforeUploadFile}
                                onChange={handleChangeFile}>
                                    {photoFile ? <img src="/img/file.png" alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                        </Form.Item>
                    </Col>
                </Row>
     
            </div>    
            <Row style={{justifyContent: 'center'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">{project ? 'Update' : 'Add'}</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody;